export default __webpack_public_path__ + "8a6e2c759221ec228417c1810e6e8895.svg";